import { useAppForm } from "@/components/ui/forms/hooks/useFormHook"
import { errorToastClassName, sonnerToast, successToastClassName, appToast as toast } from "@/components/ui/baseUi/sonner" 
import { MAX_65535_CHARACTERS } from "@/typings/formik"
import { word } from "@modules/core/utils/i18n"
import { ProgramBundleSubscriberEntity } from "@modules/programBundle/programBundleSubscribers/entities/programBundleSubscriberEntity"
import { ProgramSubscriberEntity } from "@modules/programs/programSubscriber/entities/programSubscriberEntity"
import { useProgramSubscriberActions } from "@modules/programs/programSubscriber/hooks/useProgramSubscriber"
import { z } from "zod"

const subscriberInternalNoteSchema = z.object({
  internalNote: z
    .string()
    .max(MAX_65535_CHARACTERS, word("form.maximum.characters")),
})

export function useSubscriberInternalNoteForm(
  programId: string,
  subscriberDetails: ProgramSubscriberEntity | ProgramBundleSubscriberEntity,
  moveToSubscriberDetails: () => void,
) {
  const { updateInternalNote, isUpdateInternalNote } = useProgramSubscriberActions(programId, subscriberDetails)

  const form = useAppForm({
    defaultValues: { internalNote: subscriberDetails.internalNote ?? "" },
    validators: {
      onSubmit: subscriberInternalNoteSchema,
      onBlur: subscriberInternalNoteSchema,
    },
    onSubmit: ({ value }) => {
      sonnerToast.promise(
        updateInternalNote(value.internalNote)
          .then(() => {
            toast.success(word("program.subscribers.subscriptionDetails.internalNote.success"), {
              classNames: successToastClassName(),
            })
            moveToSubscriberDetails()
          })
          .catch(() => {
            toast.error(word("global.error.label"), {
              classNames: errorToastClassName(),
            })
          }),
      )
    },
  })

  return { form, isSubmitting: isUpdateInternalNote }
}
